export enum SeasonTableColumns {
  NameLocal = "nameLocal",
  AgeGroup = "ageGroup",
  Gender = "gender",
  CompetitionId = "competitionId",
  CompetitionName = "competitionName",
  Discipline = "discipline",
  EndDate = "endDate",
  Representation = "representation",
  SeasonId = "seasonId",
  SeasonType = "seasonType",
  StartDate = "startDate",
  Standard = "standard",
  Status = "status",
  Year = "year",
  Image = "image",
  ExternalId = "externalId",
}
